export default {
  failedNotification: 'Erro ao adicionar o domínio'
}
